export const CONFIRMATION_ON_SALES = 'confirmation-on-sales';
export const PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON = 'primary-business-location-contact-person';
export const PRIMARY_BUSINESS_ADDRESS = 'primary-business-address';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const TDI_LICENCE = [
    {
        sectionID: CONFIRMATION_ON_SALES,
        sectionName: 'Confirmation on Sales for M2M, Prohibited Telecommunication Equipment or SMS SIM Box',
        fieldList: [
            {
                id: 'do-you-intend-to-sell-m2m-equipment',
                label: 'Do you intend to sell M2M Equipment?',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-intend-to-sell-prohibited-telecommunication-equipment',
                label: 'Do you intend to sell Prohibited Telecommunication Equipment?',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-intend-to-sell-sms-sim-box',
                label: 'Do you intend to sell SMS SIM Box?',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON,
        sectionName: 'Primary Business Location Contact Person Details',
        fieldList: [
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text'
            },
            {
                id: 'office-tel-number',
                label: 'Office Tel Number',
                type: 'text'
            },
            {
                id: 'mobile-number',
                label: 'Mobile Number',
                type: 'text'
            }
        ]
    },
    {
        sectionID: PRIMARY_BUSINESS_ADDRESS,
        sectionName: 'Primary Business Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level-optional',
                label: 'Floor Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
